/* eslint complexity: ["error", 8] */
import Backbone from 'backbone';
import Storage from '../../utils/Storage';
import _ from 'lodash';

let proxiedSync = Backbone.sync;

const isFGPHackCheck = (is_fgp_hack, is_json) => {
	return is_fgp_hack && is_json;
};

const isProjJson = (is_project_json, is_json) => {
	return is_project_json && is_json;
};

Backbone.sync = function(method, model, options) {
	options || (options = {});

	let model_url = typeof model.url === 'function' ? model.url() : model.url;
	let is_json = _.isString(model_url) && model_url.indexOf('.json') !== -1;
	let api_url = is_json ? process.env.STATIC_DATA_DIR_URL : process.env.API_URL;

	if (isProjJson(options.is_project_json, is_json)) {
		api_url = process.env.STATIC_DATA_DIR_URL;
	}

	if(isFGPHackCheck(model.isFGPHack, is_json)) {
		api_url = process.env.STATIC_DATA_TIPPING_DIR_URL;
	}

	if (!options.crossDomain) {
		options.crossDomain = true;
	}

	function getSettingsData(settings) {
		return settings.data || {};
	}

	function isWithSID(sid) {
		return !is_json && process.env.IS_SID === 'true' && !sid;
	}


	options.url = api_url + model_url;

	_.extend(options, {
		emulateHTTP: true,
		emulateJSON: false,
		beforeSend: function(xhr, settings) {
			settings.data = getSettingsData(settings);

			// settings.data is a body of our request.
			if (_.isString(settings.data)) {
				settings.data = Backbone.$.parseJSON(settings.data);
			}

			const is_with_sid = isWithSID(settings.data.sid);

			if (is_with_sid) {
				settings.data.sid = Storage.get('sid') || '';
			}

			if (!is_json) {
				settings.data._ = +new Date();
			}

			settings.data = Backbone.$.param(settings.data);

			if (settings.type === 'GET' && !_.isEmpty(settings.data)) {
				const sign = settings.url.split('?')[1] ? '&' : '?';
				settings.url += sign + settings.data;
			}
		}
	});

	return proxiedSync.apply(this, arguments);
};